export const FETCH_HEADER_LINKS = 'FETCH_HEADER_LINKS';
export const SET_HEADER_LINKS = 'SET_HEADER_LINKS';